import { combineReducers } from 'redux'
import misc from './misc'
import team from './team'

export default combineReducers({
  misc,
  team,
})
